
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NewResidentsComponent } from '../new-residents/new-residents.component';
import { FlaggedResidentsComponent } from '../flagged-residents/flagged-residents.component';
import { AllResidentsComponent } from '../all-residents/all-residents.component';
import { AngularMaterialModules } from 'app/angular-material-modules';

export type ResidentsView = 'new' | 'changes' | 'all';

@Component({
    selector: 'app-residents',
    templateUrl: './residents-on-landing-page.component.html',
    styleUrls: ['./residents-on-landing-page.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [TranslateModule, NewResidentsComponent, FlaggedResidentsComponent, AllResidentsComponent, AngularMaterialModules]
})
export class ResidentsLandingPageComponent implements OnInit {

  constructor() { }

  /** The resident lists to switch between */
  readonly views: { key: ResidentsView; label: string }[] = [
    { key: 'new', label: 'NEW' },
    { key: 'changes', label: 'CHANGES' },
    { key: 'all', label: 'ALL' },
  ];

  selectedView: ResidentsView = 'new';
  user: any;
  customerSelectionData: any;

  ngOnInit(): void {
    this.customerSelectionData = JSON.parse(
      localStorage.getItem("landing-page")
    );
    this.user = this.customerSelectionData.user;
  }

}
